import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { activeRecord } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';

export const operationName = 'queryTeamIds';

/**
 * GraphQL query to fetch active team name & ids.
 * @param onError custom error handling.
 * @returns custom hook that provides GraphQL query to fetch Team Names.
 */
const useQueryTeamIds = (onError: (e: ApolloError) => void) =>
  useTypedQuery(
    {
      team: [
        {
          where: {
            ...activeRecord,
            team_type: { _neq: 'SOC' },
          },
        },
        { id: true, name: true },
      ],
    },
    {
      scalars: genericScalars,
      apolloOptions: { onError },
      operationOptions: { operationName },
    }
  );

export default useQueryTeamIds;
